import React, { HTMLAttributes, ReactNode } from 'react';
import { ParagraphText as Description, Header, HeaderVariants } from '..';

export interface TableHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  description?: string;
  title: string;
  headerVariant?: HeaderVariants;
}

export const TableHeader = ({
  children,
  description,
  title,
  headerVariant,
}: TableHeaderProps) => {
  /* Checking for missing required props */
  if (!title)
    throw new Error(
      `You need to pass a prop called "title" of type string to the TableHeader component. To learn more about the list of required props for the
      TableHeader component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/tables-table--table-header`
    );
  /* Checking for missing required props finished */
  return (
    <div className="border-b border-thryv-gray-light-400 pb-[28px] px-[30px] sm:px-[15px]">
      <div className="w-full flex justify-between items-center sm:flex-col">
        <div className="w-1/2 sm:w-full">
          <Header
            variant={headerVariant ? headerVariant : 'h3'}
            fontWeight="semibold"
          >
            {title}
          </Header>
          {description && (
            <Description
              variant="reg"
              className="text-p-base text-thryv-steel font-open-sans"
            >
              {description}
            </Description>
          )}
        </div>
        <div className="w-1/2 flex justify-end items-center gap-8 sm:w-full">
          {children}
        </div>
      </div>
    </div>
  );
};
